import React, { useContext } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import logoLight from '../../assets/img/logo/main-logo-light.svg'
import logoDark from '../../assets/img/logo/main-logo-dark.svg'
import './Header.scss'
import ThemeSwitcher from '../theme-switcher/ThemeSwitcher'
import AppNotification from '../app-notification/AppNotification'
import UserMenu from '../user/UserMenu'
import { useNavigate } from 'react-router-dom';
import MainSearch from '../search/mainSearch'
import PortfolioButton from '../portfolioButton/PortfolioButton'
import { ThemeContext } from '../../context/theme-context';

export default function Header() {
    const navigate = useNavigate();
    const currentTheme = useContext(ThemeContext).theme;
    const logo = currentTheme === 'dark' ? logoDark : logoLight;

    return (
        <>
            <Container className='header-container'>
                <Row className='header-container-row'>
                    <Col className='mainLogo' onClick={() => navigate('/watchlist')} ><Image src={logo} fluid /></Col>
                    <Col xs={6}><MainSearch /></Col>
                    <Col>
                        <div className='d-flex flex-row justify-content-end w-100'>

                            <div className='portfolio-btn'><PortfolioButton /></div>
                            <div className='theme-btn'><ThemeSwitcher /></div>
                            {/* <div className='notification-btn'><AppNotification /></div> */}
                            <div className='user-btn'><UserMenu /></div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
